import { stringifyQs } from "@dashboard/utils/urls";

export const exportSection = "/export/";
export const exportOverviewPath = exportSection;
export const exportOverviewUrl = (params?: Record<string, string>) =>
  exportSection + (params ? "?" + stringifyQs(params) : "");
